const ROLES = [
  { title: "Low-Voltage Technician", salary: "$52k – $68k", icon: "ri-plug-line" },
  { title: "Network Support Tech", salary: "$55k – $72k", icon: "ri-router-line" },
  { title: "Security Systems Installer", salary: "$50k – $70k", icon: "ri-shield-check-line" },
  { title: "Fire Alarm Technician", salary: "$58k – $80k", icon: "ri-fire-line" },
  { title: "Field Service / IT Tech", salary: "$48k – $65k", icon: "ri-computer-line" },
  { title: "Structured Cabling Tech", salary: "$50k – $70k", icon: "ri-git-branch-line" },
];

export default function Outcomes() {
  return (
    <section id="outcomes" className="relative bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-mono uppercase tracking-[0.2em] mb-4">
              <i className="ri-briefcase-4-line"></i> Career Outcomes
            </div>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.05]">
              Skills that <span className="text-primary-600">pay off</span> — literally.
            </h2>
            <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed">
              Our grads step into roles at integrators, ISPs, life-safety companies, IT MSPs, and
              in-house maintenance teams. Below are typical starting-to-mid ranges in the markets
              we place into.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-4">
              <div className="p-4 rounded-lg bg-background-100 border border-background-200 text-center">
                <div className="text-3xl font-heading font-bold text-primary-600">94%</div>
                <div className="text-xs text-foreground-600 font-mono uppercase tracking-widest mt-1">
                  Placement rate
                </div>
              </div>
              <div className="p-4 rounded-lg bg-background-100 border border-background-200 text-center">
                <div className="text-3xl font-heading font-bold text-primary-600">$58k</div>
                <div className="text-xs text-foreground-600 font-mono uppercase tracking-widest mt-1">
                  Median start
                </div>
              </div>
              <div className="p-4 rounded-lg bg-background-100 border border-background-200 text-center">
                <div className="text-3xl font-heading font-bold text-primary-600">120+</div>
                <div className="text-xs text-foreground-600 font-mono uppercase tracking-widest mt-1">
                  Hiring partners
                </div>
              </div>
            </div>

            <a
              href="#apply"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-foreground-950 hover:bg-foreground-800 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer transition-colors"
            >
              Talk to Admissions
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-xl overflow-hidden border border-background-200">
              <div className="grid grid-cols-1 sm:grid-cols-2 divide-y sm:divide-y-0 sm:divide-x divide-background-200">
                {ROLES.map((r) => (
                  <div
                    key={r.title}
                    className="p-5 md:p-6 bg-background-50 hover:bg-background-100 transition-colors border-b border-background-200 last:border-b-0"
                  >
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500/10 text-primary-600 shrink-0">
                        <i className={`${r.icon} text-xl`} aria-hidden="true"></i>
                      </div>
                      <div className="min-w-0">
                        <h3 className="font-heading font-semibold text-foreground-950 text-base leading-tight">
                          {r.title}
                        </h3>
                        <div className="mt-1.5 flex items-center gap-2">
                          <span className="font-mono text-sm text-primary-700 font-semibold">
                            {r.salary}
                          </span>
                          <span className="text-[10px] uppercase tracking-widest text-foreground-500 font-mono">
                            typical
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <p className="mt-4 text-xs text-foreground-500 font-mono">
              * Salary ranges reflect roles our recent graduates have accepted. Individual results vary.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}